import { Outlet } from "react-router-dom";
import { useState } from "react";
import { useGetInspections } from "@/features/Inspections/repository/index.ts";
import { InspectionListItem } from "@/features/Inspections/pages/fragments/inspection-item";
import Table from "@/components/Table";
import Pagination from "@/components/Pagination";


const columns = [
    "Inspection ID",
    "Inspection Type",
    "Inspector",
    "Schedule Date",
    "Status",
    "Action"
];

const Inspections = () => {
    const [page, setPage] = useState<number>(0);

    // GET /inspections takes a Pageable only - the API exposes no search,
    // status or date filter for inspections, so no filter bar is rendered.
    const { inspections, isLoading } = useGetInspections({
        pager: { page: page + 1, size: 10 }
    });

    return (
        <div className="p-5 space-y-4">
            <Outlet />
            <Table.Container>
                <Table>
                    <Table.Header>
                        <Table.Row>
                            {
                                columns.map((header) => (
                                    <Table.Head key={header}>
                                        {header}
                                    </Table.Head>
                                ))
                            }
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {
                            isLoading && (
                            <Table.Loading columns={columns.length} />
                        )}

                        {
                            inspections?.results?.length === 0 && (
                            <Table.Empty />
                        )}

                        {
                            inspections &&
                            inspections?.results?.map((inspection:any) => (
                                <InspectionListItem
                                    key={inspection.id}
                                    inspection={inspection}
                                />
                            ))
                        }
                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                            <Table.Cell colSpan={columns.length}>
                                <div className="flex justify-between items-center font-light">
                                    <div>
                                        {page + 1} of &nbsp;
                                        {inspections?.pagination?.last_page}
                                    </div>
                                    <Pagination
                                        currPage={page}
                                        setCurrPage={(value) => setPage(value)}
                                        pageCount={inspections?.pagination?.last_page ?? 0}
                                    />
                                </div>
                            </Table.Cell>
                        </Table.Row>
                    </Table.Footer>
                </Table>
            </Table.Container>
        </div>
    );
};

export default Inspections;